export class Colors {

    primary: string;
    accent: string;

    constructor(primary: string, accent: string) {
        this.primary = primary;
        this.accent = accent;
    }
}
